const trans_diff_name = {
    "Comparative Transcriptome of Lotus Seed Cotyledon Development": [
        {
            "sample": "CA12DAP_vs_CA9DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "CA15DAP_vs_CA12DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "CA15DAP_vs_CA9DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY12DAP_vs_CA12DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY12DAP_vs_ZY9DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY15DAP_vs_CA15DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY15DAP_vs_ZY12DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY15DAP_vs_ZY9DAP",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "ZY9DAP_vs_CA9DAP",
            "tissue": "Cotyledon VS Cotyledon"
        }
    ],
    "Transcriptome of Lotus Seed Cotyledon Development": [
        {
            "sample": "DAP12_vs_DAP15",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP12_vs_DAP18",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP12_vs_DAP21",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP12_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP15_vs_DAP18",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP15_vs_DAP21",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP15_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP18_vs_DAP21",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP18_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP21_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP12",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP15",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP18",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP21",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP6_vs_DAP9",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP9_vs_DAP12",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP9_vs_DAP15",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP9_vs_DAP18",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP9_vs_DAP21",
            "tissue": "Cotyledon VS Cotyledon"
        },
        {
            "sample": "DAP9_vs_DAP24",
            "tissue": "Cotyledon VS Cotyledon"
        }
    ],
    "Transcriptome of Lotus Seed Plumule Development": [
        {
            "sample": "JNP12DAP_vs_JNP15DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP12DAP_vs_JNP18DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP12DAP_vs_JNP24DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP15DAP_vs_JNP18DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP15DAP_vs_JNP24DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP18DAP_vs_JNP24DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP9DAP_vs_JNP12DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP9DAP_vs_JNP15DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP9DAP_vs_JNP18DAP",
            "tissue": "Plumule VS Plumule"
        },
        {
            "sample": "JNP9DAP_vs_JNP24DAP",
            "tissue": "Plumule VS Plumule"
        }
    ]
}
let SelectOPtions=[]
Object.keys(trans_diff_name).map(key=>{
    SelectOPtions.push({
        value:key,
       label:key
    })
})
export {trans_diff_name,SelectOPtions}